import { render } from "./ManageUserSubscriptions.vue?vue&type=template&id=11480922&scoped=true"
import script from "./ManageUserSubscriptions.vue?vue&type=script&lang=js"
export * from "./ManageUserSubscriptions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11480922"]])

export default __exports__